import { toDate as o } from "./toDate.js";
function r(e, n) {
  const t = o(e);
  return t.setMinutes(n), t;
}
export {
  r as default,
  r as setMinutes
};
//# sourceMappingURL=setMinutes.js.map
